import { DataName, ActionType, ActionUpdateLayerData, GristEvent, GristStatus } from '../../util/model';

type SocketData = GristEvent | GristStatus; 

export const actionUpdateLayerData = (dataName: DataName, data: SocketData): ActionUpdateLayerData => ({
    type: ActionType.UDPATE_LAYER_DATA,
    payload: {
        dataName,
        data
    }
})
